import { Modal, ModalProps } from 'components/page/app-page/Modal';
import React from 'react';
import tw from 'twin.macro';

import { WIZARD_PANEL_MAX_WIDTH } from 'components/video-gen/wizardLayout';
import { maxWidthThatHolds } from './VideoPreviewModal';

interface IGenerateVideoModal extends ModalProps {
  /**
   * SYM-6353. Bring to Life's input screen: two columns, as wide as the
   * Track 1 video pop-up (880px), and as tall as its content up to the
   * window. The shared Modal's 50vh floor and 80vh cap are switched off: the
   * screen measures about 680px and would otherwise scroll inside a window
   * that has the room, and its footer is pinned so Generate stays in reach
   * when the window really is short.
   */
  wide?: boolean;
}

const GenerateVideoModal: React.FC<IGenerateVideoModal> = ({
  show,
  children,
  hideCloseButton,
  onClose,
  wide = false,
}) => {
  return (
    <Modal
      show={show}
      hideCloseButton={hideCloseButton}
      onClose={onClose}
      twclass={
        wide
          ? {
              ...tw`rounded-lg w-[90vw] pb-0 sm:pb-0`,
              ...maxWidthThatHolds(WIZARD_PANEL_MAX_WIDTH),
              height: 'auto',
              maxHeight: 'calc(100dvh - 2rem)',
              minHeight: '0',
            }
          : tw`grid grid-flow-row justify-center rounded-md`
      }
    >
      {wide ? children : <div tw="mt-3 mx-6">{children}</div>}
    </Modal>
  );
};

export default GenerateVideoModal;
